import React, { useState, useEffect } from "react"
import { __snackBarSeverity } from "../../constants"
import moment from "moment"
import mainContext from "../../contexts/mainContext"
import styled from "@emotion/styled"
import { Divider, Pagination } from "@mui/material"
import SearchBar from "./SearchBar"
import DisputeDetail from "./DisputeDetail"
import { getDisputedInvoicesController } from "../../Controllers/InvoiceDisputes"

export default function DisputesList() {
  const { setSnackBar, setProfileNavTitle, setPageload } = React.useContext(mainContext)
  const [state, setState] = useState({
    disputes: {},
    total: 0,
    page: 1,
    limit: 8,
    index: -1,
    selectedDispute: {},
    openDetails: false,
  })
  const [filterState, setFilterState] = React.useState({})

  useEffect(() => {
    setProfileNavTitle("Payment Disputes")
    fetchDisputes(state.page)
    // eslint-disable-next-line
  }, [])

  const callSnackBar = (msg, type) => {
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type],
    })
  }

  const fetchDisputes = async (page, isClear) => {
    let params = { page }
    if (!isClear) params = { page, ...filterState }
    setPageload(true)
    const res = await getDisputedInvoicesController(params)
    setPageload(false)
    if (res.data.status === 200) {
      const newList = {}
      res.data.data.invoices.forEach((object) => {
        const date = moment(object.createdAt).format("YYYY-MM-DD")
        newList[date] = newList[date] ? newList[date] : []
        newList[date].push(object)
      })
      setState({ ...state, disputes: newList, total: res.data.data.total, page: res.data.data.page })
    } else {
      callSnackBar(res.data.errors[0].message, "error")
    }
  }

  const handleView = (dispute, index) => {
    setState({ ...state, openDetails: true, selectedDispute: dispute, index: index })
  }

  const handleCb = (status, date, index, adminRemark) => {
    const newDate = moment(date).format("YYYY-MM-DD")
    const temp = { ...state.disputes }
    temp[newDate][index].dispute.status = status
    if (adminRemark) {
      temp[newDate][index].dispute.adminRemark = adminRemark
    }
    setState({ ...state, disputes: temp, openDetails: false })
  }

  const getRaisedByInfo = (dispute) => {
    if (!dispute.dispute || !dispute.dispute.raisedBy || dispute.dispute.raisedBy.length === 0) {
      return "N/A"
    }

    // If there are multiple raisers, show a combined string
    if (dispute.dispute.raisedBy.length > 1) {
      return "Both parties"
    }

    const raisedBy = dispute.dispute.raisedBy[0]

    if (raisedBy.role === "Seeker") {
      return `${dispute.invoiceInfo.payBy.firstName || ""} ${dispute.invoiceInfo.payBy.lastName || ""} (Customer)`
    } else if (raisedBy.role === "HouseKeeper") {
      return `${dispute.invoiceInfo.payTo.firstName || ""} ${dispute.invoiceInfo.payTo.lastName || ""} (Housekeeper)`
    } else if (raisedBy.role === "BabySitter") {
      return `${dispute.invoiceInfo.payTo.firstName || ""} ${dispute.invoiceInfo.payTo.lastName || ""} (Babysitter)`
    }

    return "N/A"
  }

  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "status_pending"
      case "Resolved":
        return "status_resolved"
      case "Rejected":
        return "status_rejected"
      default:
        return ""
    }
  }

  return (
    <>
      <SearchBar filterState={filterState} setFilterState={setFilterState} callFunction={fetchDisputes} />
      <Container className="scrollbar">
        <Body>
          {Object.entries(state.disputes).length > 0 && (
            <>
              <Divider className="divider-gap" />
              <List className="header-row">
                <div className="header">Status</div>
                <div className="header">Invoice No.</div>
                <div className="header">Raised By</div>
                <div className="header">Job No.</div>
                <div className="header">Payer</div>
                <div className="header">Payee</div>
                <div className="header"></div>
              </List>
              <Divider className="divider-gap" />
            </>
          )}

          {Object.entries(state.disputes).map((list, index) => (
            <React.Fragment key={index}>
              {list[1].map((dispute, index2) => (
                <React.Fragment key={dispute._id}>
                  <List>
                    <div>
                      <div className={`list_card_status ${getStatusClass(dispute.dispute.status)}`}>
                        {dispute.dispute.status}
                      </div>
                    </div>
                    <div>{dispute.invoiceNo}</div>
                    <div>{getRaisedByInfo(dispute)}</div>
                    <div>{dispute.jobId.displayedJobId || ""}</div>
                    <div>{`${dispute.invoiceInfo.payBy.firstName || ""} ${dispute.invoiceInfo.payBy.lastName || ""}`}</div>
                    <div>{`${dispute.invoiceInfo.payTo.firstName || ""} ${dispute.invoiceInfo.payTo.lastName || ""}`}</div>
                    <button className="list_card_view_btn" onClick={() => handleView(dispute, index2)}>
                      View
                    </button>
                  </List>
                  {/* {(index < Object.entries(state.disputes).length - 1 || index2 < list[1].length - 1) && (
                    <Divider className="divider-gap" />
                  )} */}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}

          {Object.entries(state.disputes).length === 0 && (
            <div className="no-record">
              <span>No Record Found</span>
            </div>
          )}
        </Body>
      </Container>
       {Object.entries(state.disputes).length > 0 && (
        <PaginationContainer>
          <Pagination
            count={Math.ceil(state.total / state.limit)}
            color="primary"
            shape="rounded"
            page={state.page}
            onChange={(e, page) => {
              setState((prev) => ({ ...prev, page }))
              fetchDisputes(page)
            }}
          />
        </PaginationContainer>
      )}
      
      <DisputeDetail
        open={state.openDetails}
        handleClose={() => setState({ ...state, openDetails: false })}
        data={state.selectedDispute}
        cb={handleCb}
        index={state.index}
      />
    </>
  )
}
const Container = styled("div")`
  .divider-gap{
    margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
  overflow-x: auto;
  margin-bottom: 10px;
`

const Body = styled("div")`
  max-height: 70vh;
  width: 100%;
  min-width: 1000px;
  margin-bottom: 10px;
  overflow-y: auto;
`

const List = styled("div")`
  &.header-row .header{
    font-family: "semi-bold";
    font-weight: 600;
  }
  .header{
    font-family: "semi-bold";
  }
  margin-top: 1.2rem;
  display: grid;
  column-gap: 0.5rem;
  grid-template-columns: minmax(0,0.8fr) minmax(0,1fr) minmax(0,1.5fr) minmax(0,1fr) minmax(0,1.2fr) minmax(0,1.2fr) minmax(0,0.6fr);
  align-items: center;
  font-size: 14px;
`

const PaginationContainer = styled("div")`
  display: flex;
  margin-top: 30rem;
  margin-bottom: 1rem;
  padding-right: 1rem;
`

